// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"112":"8de8f7f0","138":"b72651fa","550":"b72651fa","757":"b72651fa","852":"4764e2c7"}[chunkId] + ".chunk.css";
};